export enum ShortStockStatus {
  Available,
  UnavailableAfterOtherOrders,
  UnavailableImmediately
}